import { createSelector } from "@ngrx/store";
import { AppState } from "../store.model";

const loggedUserFilter = (state: AppState) => state.loggedUser;

export const selectLoggedUser = createSelector(
    loggedUserFilter,
    (content) => content
)